import React from "react";

const HairMaskTestmonial = () => {
  return (
    <div className="hairSubServiceCustomer">
      <h5>Why Bangaloreans Love SCENT’s Hair Masks</h5>
      <p>
        Residents of Bangalore trust{" "}
        <a href="https://scentlifestyle.com/">SCENT</a> for their hair care
        needs because of our commitment to quality and customer satisfaction.
        Our hair masks in Bangalore have become a favorite among clients who
        seek effective treatments in a serene and professional setting.
      </p>
      <div className="hairSubServiceCustomerContent">
        <h6>Client Testimonials</h6>
        <p>
          <span className="quote">“</span>The hydrating hair mask at SCENT
          completely transformed my dry hair! It’s so soft and manageable now.
          <span className="quote">”</span> - <span>Anjali </span>
        </p>
        <p>
          <span className="quote">“</span>I love how SCENT’s experts customized
          a hair mask treatment just for me. My frizz is gone, and my hair looks
          amazing!
          <span className="quote">”</span> - <span> Rahul </span>
        </p>
        <p>
          <span className="quote">“</span>SCENT offers the best hair masks in
          Bangalore. The experience was relaxing, and my hair feels stronger and
          healthier
          <span className="quote">”</span> - <span> Priya </span>
        </p>
      </div>
    </div>
  );
};

export default HairMaskTestmonial;
